export class Guard {
  static require<T>(input: T, name: string) {
    if (input === null || input === undefined)
      throw new Error(`${name} is required.`);
  }
}
